import { Component, Input, OnInit, signal } from "@angular/core";
import {
  AppConfigService,
  formatTimezone,
  IAppointment,
  IAppointmentRouting,
} from "../../../../core-ui";
import moment from "moment";

@Component({
  selector: "av-appointment-calendar",
  templateUrl: "./appointment-calendar.component.html",
  styleUrls: ["./appointment-calendar.component.scss"],
})
export class AppointmentCalendarComponent implements OnInit {
  @Input() appointment: IAppointment<IAppointmentRouting>;

  timezoneOffset = signal<string>(null);
  lang = signal<string>(undefined);

  constructor(private config: AppConfigService) {
    this.lang.set(this.config.language);
  }

  ngOnInit(): void {
    this.timezoneOffset.set(
      formatTimezone(
        moment.tz(this.appointment.start, this.appointment.timezone)
      )
    );
  }
}
